import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';
@Injectable({
  providedIn: 'root'
})
export class TransactionsService extends BaseService {

  constructor() {
    super();
  }
  getSelectedRetailer(id: number): Observable<any> {
    return this.httpService.get(`${APIUrl.getRetailer}/${id}`);
  }
  getAllTransactionSummary(params): Observable<any> {
    let url = APIUrl.getTransactionSummary;
    return this.httpService.getParams(url,params)
}
  getTransactionSummaryRange(startDate, endDate):Observable<any>{
    let params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
    let url = APIUrl.consumerAllTransactions;
    return this.httpService.getParams(url, params)
  }
  getAllTransactions(params):Observable<any> {
    let url = APIUrl.consumerAllTransactions;
    return this.httpService.getParams(url,params)
  }
  getAllTransactionRange(startDate, endDate): Observable<any> {
    let params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
    let url = APIUrl.getAllTransactions;
    return this.httpService.getParams(url, params)
  }
  approvePinlessrefund(params) {
    return this.httpService.post(APIUrl.pinlessrefund, params);
  }
}

